import { logoComponent } from './logo.component';

export const LogoModule = angular
    .module('app.components.logo', [])
    .component('logo', logoComponent)
    .name;


// WEBPACK FOOTER //
// ./src/app/components/logo/logo.module.js